<form #formulario="ngForm">
    <mat-accordion>

        <mat-expansion-panel [expanded]="openFormCadastro" (closed)="openFormCadastro = false">
            <mat-expansion-panel-header>
                <mat-panel-title>Dados da Unidade</mat-panel-title>
            </mat-expansion-panel-header>

            <div fxLayout="row" fxLayoutGap="50px" style="margin-top: 10px; margin-bottom: 10px" fxFlexFill>
                <mat-form-field fxFlex="100%" fxFlexOffset="20px">
                    <mat-label>Unidade</mat-label>
                    <mat-select [(ngModel)]="unidade" name="unidade" required>
                        <mat-option *ngFor="let m of unidadesComboCadastro" [value]="m">
                            {{m.nomeUnidade}}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>


            <div dir="rtl" fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="20px"
                style="padding-top: 20px; padding-bottom: 10px; padding-right: 20px" fxFlexFill>

                <button mat-raised-button name="botaoLimpar" fxFlex="20%" color="primary" (click)="limpar()">
                    Limpar
                </button>

                <button mat-raised-button name="botaoAdicionar" [disabled]="!unidade.idUnidade" fxFlex="20%" color="primary" (click)="adicionar()">
                    Adicionar
                </button>

            </div>

        </mat-expansion-panel>


        <mat-expansion-panel [expanded]="!openFormCadastro" (opened)="carregarLista()"
            (closed)="openFormCadastro = true">
            <mat-expansion-panel-header>
                <mat-panel-title>
                    Lista de Unidades ( {{unidades?.length}} )
                </mat-panel-title>
            </mat-expansion-panel-header>

            <table *ngIf="mostrarTabela; else tabelaSemDados" mat-table [dataSource]="dataSource"
                style="margin-top: 20px">

                <ng-container matColumnDef="nomeUnidade" >
                    <th mat-header-cell *matHeaderCellDef> Nome </th>
                    <td mat-cell *matCellDef="let element"> {{element.nomeUnidade}} </td>
                </ng-container>

                <ng-container matColumnDef="siglaUnidade">
                    <th mat-header-cell *matHeaderCellDef> Sigla </th>
                    <td mat-cell *matCellDef="let element"> {{element.siglaUnidade}} </td>
                </ng-container>

                <ng-container matColumnDef="nomeFantasia">
                    <th mat-header-cell *matHeaderCellDef> Nome fantasia</th>
                    <td mat-cell *matCellDef="let element"> {{element.nomeFantasia}} </td>
                </ng-container>

                <ng-container matColumnDef="cnpj">
                    <th mat-header-cell *matHeaderCellDef> CNPJ </th>
                    <td mat-cell *matCellDef="let element"> {{element.cnpj | cnpj}} </td>
                </ng-container>

                <ng-container matColumnDef="acoes">
                    <th mat-header-cell *matHeaderCellDef> Ações </th>
                    <td mat-cell *matCellDef="let element">
                        <button *ngIf="perfilAcesso.deleta && unidades?.length > 1" mat-button (click)="deletar(element)">
                            <mat-icon>delete</mat-icon>
                        </button>
                    </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr mat-row  *matRowDef="let row; columns: displayedColumns;"></tr>
            </table>

            <div [hidden]="!mostrarTabela">
                <mat-paginator [pageSizeOptions]="[5]" showFirstLastButtons></mat-paginator>
            </div>

            <ng-template #tabelaSemDados>
                <div fxLayout="row" fxLayoutAlign="center center" style="padding-top: 10px">
                    {{msg}}
                </div>
            </ng-template>

            <div fxLayout="row" *ngIf="perfilAcesso.insere" fxLayoutAlign="end center" fxLayoutGap="16px"
                style="padding-top: 30px">
                <div>
                    <button matTooltip="Adicionar nova unidade" mat-fab color="primary" (click)="novo()">
                        <mat-icon>add</mat-icon>
                    </button>
                </div>
            </div>


        </mat-expansion-panel>

    </mat-accordion>
</form>